import { render, staticRenderFns } from "./ConfigLogsList.vue?vue&type=template&id=8b099b4c&scoped=true&"
import script from "./ConfigLogsList.vue?vue&type=script&lang=js&"
export * from "./ConfigLogsList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigLogsList.vue?vue&type=style&index=0&id=8b099b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b099b4c",
  null
  
)

export default component.exports